import { render, staticRenderFns } from "./HrContractStructureUpdate.vue?vue&type=template&id=4d63c68c&lang=pug&"
import script from "./HrContractStructureUpdate.vue?vue&type=script&lang=js&"
export * from "./HrContractStructureUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrContractStructureUpdate.vue"
export default component.exports